/**
 * @generated SignedSource<<d955fc6b5858a8ee35dcd0d6a7c8949b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingWriteAccess = "FULL_WRITE" | "JOIN" | "NONE" | "NON_OWNER_WRITE";
export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";
export type TransportationCode = "CADDIE" | "CADDIE_CART" | "CART" | "FULL_CART" | "MOTOR_PULL_CART" | "PRIVATE_CART" | "PULL_CART" | "SINGLE_CART" | "WALK";
import { FragmentRefs } from "relay-runtime";
export type AgendaWaitlistBooking_Booking$data = {
  readonly canUpdate: boolean | null | undefined;
  readonly id: string;
  readonly request?: {
    readonly id: string;
    readonly time: string;
  } | null | undefined;
  readonly rounds: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly courseLayout: {
          readonly holeCount: HoleCount;
          readonly id: string;
        } | null | undefined;
        readonly id: string;
        readonly player: {
          readonly __typename: string;
          readonly firstName: string | null | undefined;
          readonly id: string;
          readonly lastName: string | null | undefined;
        } | null | undefined;
        readonly transportationType: {
          readonly code: TransportationCode | null | undefined;
          readonly id: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly startSlot: {
    readonly agenda?: {
      readonly date: string;
    };
    readonly id: string;
  } | null | undefined;
  readonly writeAccess: BookingWriteAccess | null | undefined;
  readonly " $fragmentType": "AgendaWaitlistBooking_Booking";
};
export type AgendaWaitlistBooking_Booking$key = {
  readonly " $data"?: AgendaWaitlistBooking_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"AgendaWaitlistBooking_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "rounds"
        ]
      }
    ]
  },
  "name": "AgendaWaitlistBooking_Booking",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canUpdate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "writeAccess",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Agenda",
              "kind": "LinkedField",
              "name": "agenda",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "date",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "QueueSlot",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "rounds",
      "args": null,
      "concreteType": "RoundConnection",
      "kind": "LinkedField",
      "name": "__booking_rounds_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TransportationType",
                  "kind": "LinkedField",
                  "name": "transportationType",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseLayout",
                  "kind": "LinkedField",
                  "name": "courseLayout",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "holeCount",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "player",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Request",
          "kind": "LinkedField",
          "name": "request",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "time",
              "storageKey": null
            },
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "StandardBooking",
      "abstractKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "9ac8cc9cd131f9eec18868ce9cfd4d9a";

export default node;
